var map = {
	"./9mobile-logo.svg": "6ee5",
	"./aedc-logo.svg": "fa8d",
	"./airtel-logo.svg": "d5ac",
	"./app-preview.svg": "81b8",
	"./arrow.svg": "27e4",
	"./burgers/burger-1.svg": "b963",
	"./burgers/burger-2.svg": "39cc",
	"./burgers/burger-3.svg": "61f0",
	"./burgers/burger-4.svg": "96fa",
	"./burgers/burger-5.svg": "d7e1",
	"./calendar.svg": "d71f",
	"./cancelled-transaction.svg": "3a5d",
	"./cart-colored.svg": "c705",
	"./cart-icon.svg": "c95a",
	"./change-pin.svg": "51a9",
	"./check-mark-circle.svg": "236d",
	"./check-mark-circular.svg": "ee3a",
	"./check-mark-success.svg": "65ac",
	"./check-mark.svg": "37e8",
	"./checkbox-unchecked.svg": "a845",
	"./chevron-down-white.svg": "72b6",
	"./chevron-down.svg": "5d56",
	"./chevron-right.svg": "4308",
	"./close-icon.svg": "9b7f",
	"./confetti-cup.svg": "0b86",
	"./copy-icon.svg": "7f35",
	"./dark-mode.svg": "6b33",
	"./dashboard-cards/bolt.svg": "f8cc",
	"./dashboard-cards/box.svg": "6686",
	"./dashboard-cards/buy-data.svg": "82f5",
	"./dashboard-cards/device.svg": "fdd8",
	"./dashboard-cards/electricity.svg": "deae",
	"./dashboard-cards/flight.svg": "739b",
	"./dashboard-cards/mobile-phone.svg": "d2d9",
	"./dashboard-cards/payment-card-green.svg": "c036",
	"./dashboard-cards/payment-card.svg": "1d48",
	"./dashboard-cards/reward-pack.svg": "c444",
	"./dashboard-cards/shop.svg": "1161",
	"./dashboard-cards/transfer.svg": "4804",
	"./dashboard-cards/tv.svg": "0eee",
	"./dashboard-cards/users.svg": "91df",
	"./dashboard-cards/wallet.svg": "838f",
	"./dashboard-cards/withdraw-funds.svg": "64e3",
	"./dashboard-icon-light.svg": "4187",
	"./delete.svg": "2c46",
	"./down-chevron.svg": "37ff",
	"./dstv.svg": "4ad9",
	"./edit-profile-icon.svg": "d07b",
	"./empty-list.svg": "09f8",
	"./encrypt.svg": "934e",
	"./eye-closed.svg": "dfc7",
	"./eye-icon-active.svg": "07f6",
	"./eye-icon-white.svg": "e393",
	"./eye-icon.svg": "e21f",
	"./failure-toast-icon.svg": "0121",
	"./fallback-image.png": "77da",
	"./fallback-image.svg": "d93f",
	"./family-wallet.svg": "30bd",
	"./family.svg": "7bb6",
	"./filter.svg": "b05f",
	"./fingerprint.svg": "a3be",
	"./first_bank-logo.svg": "3ea4",
	"./gift.svg": "754a",
	"./globacom-logo.svg": "e703",
	"./gotv.svg": "90e30",
	"./hamburger-logo-white.svg": "03dd",
	"./info-toast-icon.svg": "7637",
	"./key-icon.svg": "708f",
	"./legend-pay-logo-dark.svg": "f4d1",
	"./legend-pay-logo-light.svg": "a7e7",
	"./legend-pay-logo-mini copy.svg": "d288",
	"./legend-pay-logo-mini.svg": "aa93",
	"./light-mode.svg": "98bd",
	"./logout-icon.svg": "1fd6",
	"./mail-profile.svg": "4d03",
	"./mtn-logo.svg": "d96d",
	"./notification-icon.svg": "a565",
	"./pana.svg": "133c",
	"./paymets.svg": "285e",
	"./pending-transaction.svg": "6303",
	"./phone-icon.svg": "04e4",
	"./phone.svg": "cf63",
	"./print.svg": "01be",
	"./qr-code.svg": "e6cf",
	"./receipt-logo.svg": "8574",
	"./reward-pack.svg": "1389",
	"./search.svg": "22ee",
	"./shop-icon-light.svg": "8585",
	"./showmax.svg": "247b",
	"./sort.svg": "884a",
	"./startimes.svg": "b449",
	"./subscription-icon-light.svg": "c975",
	"./success-icon.svg": "40f0",
	"./success-toast-icon.svg": "34e1",
	"./transaction-icon-light.svg": "e3d8",
	"./transaction-icon.svg": "a28b",
	"./trash-icon.svg": "d878",
	"./trolley.svg": "54ab",
	"./users-white.svg": "9dc8",
	"./users.svg": "4e3e",
	"./verification-failed.svg": "3ab9",
	"./verification-successful.svg": "9c33",
	"./wallet.svg": "b23e",
	"./withdraw-funds.svg": "6d09"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";